export default {
    name: 'rgo-event-manager',
    version: '2.20.0',
}
